import Swal from 'sweetalert2';

/* 🔥 GLOBAL ALERT OVERRIDE */
window.alert = (message) => {
  const msg = String(message).toLowerCase();

  let icon = 'info';

  if (
    msg.includes('success') ||
    msg.includes('added') ||
    msg.includes('updated') ||
    msg.includes('saved') ||
    msg.includes('deleted')
  ) {
    icon = 'success';
  } else if (
    msg.includes('error') ||
    msg.includes('fail') ||
    msg.includes('failed') ||
    msg.includes('wrong')
  ) {
    icon = 'error';
  } else if (
    msg.includes('warning') ||
    msg.includes('confirm')
  ) {
    icon = 'warning';
  }

  Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title: String(message),
    timer: 1300,
    showConfirmButton: false,
    timerProgressBar: true,
  });
};

/* 🔥 GLOBAL CONFIRM OVERRIDE */
window.confirm = (message) => {
  return Swal.fire({
    title: 'Confirm',
    text: String(message),
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
  }).then((result) => result.isConfirmed);
};
